import React, { Component } from "react";
import "./material.css";
import "./DialogueApp.css";
import { AnnotationAPI, LevelRecordAPI, StudentAPI } from "./api.js";
import CoinDropSound from "./coin-total-up.wav";
import { PTNarratorBox, PTYouDialogue } from "./static_dialogue.js";
import { PTMeDialogue } from "./selectable_dialogue.js";
import { PTLearnometer } from "./learnometer.js";
import ReactAudioPlayer from "react-audio-player";
import { getAvatarUrl, getPetUrl } from "./utils/avatar";
import { Settings } from "./settings";
import { Log } from "./log.js";
import Coins from "./coins/Coins";

const api = new AnnotationAPI("/api/");
const lrApi = new LevelRecordAPI("/api/");
const studentAPI = new StudentAPI("/api/");
const log = new Log(Settings.logLevel);

let already_completed = false;

class PTCompleteButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAnimation: false,
      isSubmitted: false,
    };
    this.onClick = this.onClick.bind(this);
    this.coinDropSound = new Audio(CoinDropSound);
  }
  render() {
    let learnometer = 0;
    if (this.props.learnometer) {
      learnometer = this.props.learnometer;
    }
    return (
      <span>
        <button
          className="pt-dialogue-complete-button"
          disabled={this.state.isSubmitted}
          onClick={this.onClick}
        >
          Done
        </button>
        {this.state.showAnimation && (
          <div className="coinanimation-dialogue">
            <span className="reward-text">
              {learnometer * 10 < 100 ? 100 : learnometer * 10}+
            </span>
          </div>
        )}
      </span>
    );
  }
  onClick() {
    // Updates coins at the end of the level
    if (!already_completed) {
      this.setState({ showAnimation: true, isSubmitted: true });
      setTimeout(() => {
        this.coinDropSound.play();
        let learnometer = 0;
        if (this.props.learnometer) {
          learnometer = this.props.learnometer;
        }
        let coins = learnometer * 10;
        if (coins < 100) {
          coins = 100;
        }
        this.props.addCoins(coins);
        studentAPI
          .post_coin(coins)
          .then((response) => response.json())
          .then((data) => setTimeout(() => (window.location = "/"), 1000));
      }, 2100);
    } else {
      window.location = "/";
    }
  }
}

class PTWhiteboard extends Component {
  render() {
    if (this.props.img)
      return (
        <div className="pt-whiteboard">
          <img src={this.props.img} />
        </div>
      );
    else return <div className="pt-whiteboard" />;
  }
}

class PTPlayButton extends Component {
  render() {
    return (
      <div className="pt-play-button-full">
        <i
          className="pt-play-button material-icons"
          onClick={this.props.onClick}
        >
          {this.props.playing ? "pause_circle_filled" : "play_circle_filled"}
        </i>
      </div>
    );
  }
}

class PTDialogueApp extends Component {
  constructor(props) {
    super(props);
    if (this.props.level.actions.length !== 1) {
      throw { error: "Dialogue levels must have exactly 1 action attached." };
    }
    log.debug("Initialized dialogue app");
    const storyJSON = JSON.parse(this.props.level.dialogueJSON);
    this.story = new window.Story(storyJSON);
    window.story = this.story;
    this.setStateKey = this.setStateKey.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.mouseOverHandler = this.mouseOverHandler.bind(this);
    this.mouseOutHandler = this.mouseOutHandler.bind(this);
    this.choiceSelectionDidComplete =
      this.choiceSelectionDidComplete.bind(this);
    this.continueStory = this.continueStory.bind(this);
    this.getAudioSource = this.getAudioSource.bind(this);
    this.knotTextDidDisplay = this.knotTextDidDisplay.bind(this);
    this.knotAudioDidPlay = this.knotAudioDidPlay.bind(this);
    this.knotAudioWasNotFound = this.knotAudioWasNotFound.bind(this);
    this.learnometerDidUpdate = this.learnometerDidUpdate.bind(this);

    this.story.ObserveVariable("l", this.setStateKey);
    this.story.ObserveVariable("wb", this.setStateKey);
    this.story.ObserveVariable("background", this.setStateKey);
    this.story.ObserveVariable("full", this.setStateKey);
    this.story.ObserveVariable("half", this.setStateKey);
    this.story.ObserveVariable("loss", this.setStateKey);

    this.actor = "narrator";
    this.state = {
      status: this.props.status,
      annotations: this.props.annotations,
      options: [],
      narratorText: "",
      youText: "",
      l: this.getStoryVar("l"),
      // background: this.getStoryVar("background"),
      background:
        "https://d135lw6vh1h84k.cloudfront.net/peerteach.us/images/bg-classroom-empty.png",
      full: this.getStoryVar("full"),
      half: this.getStoryVar("half"),
      loss: this.getStoryVar("loss"),
      wb: this.getStoryVar("wb"),
      activeIndex: undefined,
      chosenIndex: undefined,
      defaultDelay: 800,
      path: [],

      knotTextDidDisplay: false,
      knotAudioDidPlay: false,
      knotAudioWasNotFound: false,
      learnometerDidUpdate: false,
      learnometerUpdateNotNeeded: false,
      choiceSelectionDidComplete: false,
      playthroughDidComplete: false,
      userInteracted: false,
      profile: null,
    };
    if (this.props.status === "complete") {
      already_completed = true;
    }
    this._ann_id = 0;
    this._ann_id = Math.max(...this.state.annotations.map((a) => a.id)) + 1;
  }

  render() {
    const profile = this.state.profile;
    let style = {};
    if (this.state.background) {
      style = { backgroundImage: "url(" + this.state.background + ")" };
    }
    return (
      <div>
        <img
          src="https://d135lw6vh1h84k.cloudfront.net/peerteach.us/images/bg-classroom-no-planet.jpg"
          className="body-bg"
          alt=""
        ></img>
        {profile && <Coins coins={profile.coins ? profile.coins : 0} />}
        <div className="pt-dialogue-app" style={style}>
          {profile && getPetUrl(profile.avatar) && (
            <img
              className={"pt-dialogue-pet"}
              src={getPetUrl(profile.avatar)}
              alt="Pet"
            />
          )}
          {profile && (
            <div className="pt-dialogue-avatar">
              <img
                src={getAvatarUrl(profile.avatar || {})}
                alt={profile.first_name}
              />
            </div>
          )}
          {profile && (
            <div className="pt-dialogue-avatar-coach">
              <img
                src={
                  "https://d135lw6vh1h84k.cloudfront.net/peerteach.us/images/coach.png"
                }
                alt="Coach"
              />
            </div>
          )}
          <PTLearnometer
            ref={(element) => {
              this.learnometer = element;
            }}
            value={this.state.l}
            full={this.state.full}
            half={this.state.half}
            loss={this.state.loss}
            completionHandler={this.learnometerDidUpdate}
          />
          <PTWhiteboard img={this.state.wb} />
          <PTNarratorBox
            text={this.state.narratorText}
            activeIndex={this.state.activeIndex}
            completionHandler={this.knotTextDidDisplay}
            delay={this.state.defaultDelay}
          />
          <div className="pt-dialogue-me-wrapper">
            {this.state.options.map(function (o, i) {
              return (
                <PTMeDialogue
                  text={o.text}
                  audioSrc={this.getAudioSource(i)}
                  index={i}
                  activeIndex={this.state.activeIndex}
                  clickHandler={this.clickHandler}
                  mouseOverHandler={this.mouseOverHandler}
                  mouseOutHandler={this.mouseOutHandler}
                  completionHandler={this.choiceSelectionDidComplete}
                />
              );
            }, this)}
          </div>
          <PTYouDialogue
            text={this.state.youText}
            completionHandler={this.knotTextDidDisplay}
            delay={this.state.defaultDelay}
          />
          {this.state.userInteracted ? (
            <ReactAudioPlayer
              ref={(element) => {
                this.knotAudio = element;
              }}
              src={this.getAudioSource()}
              onEnded={this.knotAudioDidPlay}
              onError={this.knotAudioWasNotFound}
              autoPlay={true}
            />
          ) : (
            <PTPlayButton
              playing={this.state.userInteracted}
              onClick={() => this.setState({ userInteracted: true })}
            />
          )}
          {this.state.status === "complete" ? (
            <PTCompleteButton
              addCoins={(newCoins) =>
                this.setState((prev) => ({
                  profile: {
                    ...prev.profile,
                    coins: prev.profile.coins + newCoins,
                  },
                }))
              }
              learnometer={this.state.l}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  continueStory() {
    while (this.story.canContinue) {
      const text = this.story.Continue();
      if (text.indexOf("NARRATOR:") === 0) {
        this.actor = "narrator";
      } else if (text.indexOf("YOU:") === 0) {
        this.actor = "you";
      } else if (text.indexOf("ME:") === 0) {
        this.actor = "me";
      } else if (this.actor === "narrator") {
        this.setState({ _narratorText: text });
      } else if (this.actor === "you") {
        this.setState({ _youText: text });
      } else if (this.actor === "me") {
        log.debug("Discarding 'me' text: " + text);
      } else {
        throw { error: "Unexpected story syntax" };
      }
    }
  }

  // When the dialogue app mounts, start the first update phase.
  componentDidMount() {
    this.setState({ phase: "update" });
    studentAPI
      .get_profile()
      .then((response) => response.json())
      .then((res) => this.setState({ profile: res }));
  }

  // When the component updates, it may be time to advance the phase.
  // Then, if the phase has changed, launch async activities.
  componentDidUpdate(prevProps, prevState) {
    if (this.state.phase !== prevState.phase) {
      if (this.state.phase === "presentation") this.beginPresentationPhase();
      if (this.state.phase === "choice") this.beginChoicePhase();
      if (this.state.phase === "update") this.beginUpdatePhase();
    }
    this.advancePhaseIfConditionsMet(prevState);
  }

  // Checks whether we can advance to the next phase. If so, set the state's phase
  // to the next phase and reset other relevant state keys.
  advancePhaseIfConditionsMet(prevState) {
    if (prevState.phase === "presentation") {
      if (
        this.state.knotTextDidDisplay &&
        (this.state.knotAudioDidPlay || this.state.knotAudioWasNotFound)
      )
        this.setState({
          phase: "choice",
          knotTextDidDisplay: false,
          knotAudioDidPlay: false,
          knotAudioWasNotFound: false,
          learnometerDidUpdate: false,
          learnometerUpdateNotNeeded: false,
          options: this.story.currentChoices.map(function (opt) {
            return { text: opt.text };
          }),
        });
    } else if (prevState.phase === "choice") {
      if (this.state.choiceSelectionDidComplete) {
        this.setState({
          phase: "update",
          options: [],
          _narratorText: "",
          _youText: "",
          activeIndex: undefined,
          chosenIndex: undefined,
          choiceSelectionDidComplete: false,
        });
        if (this.state.status === "not_started") {
          lrApi.level_started(this.props.id).then((resp) => {
            this.setState({ status: "started" });
          });
        }
      }
    } else if (prevState.phase === "update") {
      if (
        this.state.learnometerDidUpdate ||
        this.state.learnometerUpdateNotNeeded
      )
        this.setState({
          phase: "presentation",
          learnometerDidUpdate: false,
          learnometerUpdateNotNeeded: false,
        });
    } else {
      console.log({ error: "Unknown state: " + this.state.phase });
      // throw { error: "Unknown state: " + this.state.phase };
    }
  }

  beginPresentationPhase() {
    log.info("Starting presentation phase");
    // Story updates were cached in underscore values until the learnometer completed
    this.setState({
      path: this.getPath(),
      narratorText: this.state._narratorText,
      youText: this.state._youText,
    });
  }

  // The choice phase presents options and handles user interaction with options.
  // When there are no remaining options, the level is over; this phase handles
  // the required actions for ending the level as well.
  beginChoicePhase() {
    log.info("Starting choice phase");
    if (this.story.currentChoices.length === 0) {
      if (!this.state.playthroughDidComplete) {
        this.setState({ playthroughDidComplete: true }, () => {
          log.debug("Playthrough is complete; logging path");
          this.logPath();
        });
      }
      if (this.state.status !== "complete") {
        lrApi.level_complete(this.props.id).then((resp) => {
          this.setState({ status: "complete" });
        });
      }
    }
  }

  // Unravels the story as far as possible. Then, if there are
  // learnometer updates, completes them before continuing.
  // this.continueStory sets underscore properties, so that they
  // don't take effect until the next presentation phase.
  beginUpdatePhase() {
    log.info("Starting update phase");
    let previousL = this.story.state.variablesState.l;
    this.continueStory();
    if (previousL === this.story.state.variablesState.l) {
      log.debug("Learnometer update not needed");
      this.setState({ learnometerUpdateNotNeeded: true });
    }
  }

  knotTextDidDisplay() {
    this.setState({ knotTextDidDisplay: true });
  }

  knotAudioDidPlay() {
    this.setState({ knotAudioDidPlay: true });
  }
  knotAudioWasNotFound() {
    this.setState({ knotAudioWasNotFound: true });
  }
  learnometerDidUpdate() {
    log.debug("Learnometer completion handler called.");
    this.setState({ learnometerDidUpdate: true });
  }
  choiceSelectionDidComplete(index) {
    this.story.ChooseChoiceIndex(index);
    this.setState({ choiceSelectionDidComplete: true });
  }

  getStoryVar(name) {
    // throws errors if var not found
    try {
      return this.story.state.variablesState.GetVariableWithName(name)._value;
    } catch (e) {
      log.debug("Could not read value of '" + name + "' from ink code");
    }
  }

  logPath() {
    let annotations = this.state.annotations.slice();
    api
      .create_annotation({
        id: this.nextId(),
        timestamp: new Date().toISOString(),
        videoTime: -1,
        comments: JSON.stringify({
          learnometer: this.state.l,
          path: this.state.path,
        }),
        levelRecord: this.props.id,
        action: this.props.level.actions[0].id,
      })
      .then((resp) => {
        resp.json().then((annotation) => {
          annotations.push(annotation);
          annotations.sort((x, y) => x.videoTime > y.videoTime);
          this.setState({ annotations: annotations });
        });
      });
  }
  clickHandler(index) {
    if (this.state.chosenIndex === undefined)
      this.setState({
        activeIndex: index,
        chosenIndex: index,
      });
  }

  mouseOverHandler(index) {
    if (this.state.chosenIndex === undefined)
      this.setState({ activeIndex: index });
  }

  mouseOutHandler(index) {
    if (
      this.state.activeIndex === index &&
      this.state.chosenIndex === undefined
    )
      this.setState({ activeIndex: undefined });
  }

  setStateKey(key, value) {
    var newState = {};
    newState[key] = value;
    this.setState(newState);
  }

  getPath() {
    window.story = this.story;
    return Object.entries(this.story.state.turnIndices)
      .filter((e) => e[0])
      .sort((a, b) => a[1] - b[1])
      .map((e) => e[0]);
  }

  currentKnot() {
    return this.state.path.length > 0
      ? this.state.path[this.state.path.length - 1]
      : "";
  }

  nextId() {
    this._ann_id += 1;
    return this._ann_id;
  }

  getAudioSource(index) {
    return (
      this.props.level.mediaUrl +
      this.currentKnot() +
      (index !== undefined ? "." + index : "") +
      ".mp3"
    );
  }
}

export default PTDialogueApp;



// WEBPACK FOOTER //
// ./src/DialogueApp.js